<template>
  <div class="home">
    <div class="hero-home">
      <div class="overlay d-md-none"></div>
      <div class="container text-md-start text-center">
        <img src="@/assets/logos/logo_45anos.png" alt="" class="hero-home-logo d-md-none">
        <h1 class="white">Trayectoria, eficiencia y resultados impecables</h1>
        <img src="@/assets/logos/logo_45anos.png" alt="" class="hero-home-logo d-md-block d-none">
      </div>
    </div>
    <div id="values">
      <div class="container">
        <h2 class="white pb-5" data-aos="fade-up">Comprometidos con cada detalle</h2>
        <div class="row">
          <div class="col-lg col-4 col-value" data-aos="fade-up" data-aos-delay="100">
            <img src="@/assets/icons/values-icons/adapt_icon.svg" alt="icono adaptabilidad">
            <p class="p-18 semi-bold">Adaptabilidad y excelencia</p>
          </div>
          <div class="col-lg col-4 col-value" data-aos="fade-up" data-aos-delay="200">
            <img src="@/assets/icons/values-icons/proceso_icon.svg" alt="icono adaptabilidad">
            <p class="p-18 semi-bold">Procesos sistematizados</p>
          </div>
          <div class="col-lg col-4 col-value" data-aos="fade-up" data-aos-delay="300">
            <img src="@/assets/icons/values-icons/personal_icon.svg" alt="icono adaptabilidad">
            <p class="p-18 semi-bold">Personal calificado</p>
          </div>
          <div class="col-lg col-6 col-value  text-lg-center text-end" data-aos="fade-up" data-aos-delay="400">
            <img src="@/assets/icons/values-icons/calidad_icon.svg" alt="icono adaptabilidad">
            <p class="p-18 semi-bold">Confianza y seguridad</p>
          </div>
          <div class="col-lg col-6 col-value text-lg-center text-start" data-aos="fade-up" data-aos-delay="500">
            <img src="@/assets/icons/values-icons/bienestar_icon.svg" alt="icono adaptabilidad">
            <p class="p-18 semi-bold">Enfoque en bienestar</p>
          </div>
        </div>
      </div>
    </div>
    <div id="servicios">
      <div class="container">
        <h2 data-aos="fade-up">Nuestros servicios</h2>
        <div class="row justify-content-center">
          <div class="col-lg-3 col-servicios" v-for="(servicio, index) in servicios" :key="index" data-aos="fade-up" :data-aos-delay="index * 100">
            <router-link :to="`/servicios/${index}#main-servicios`" class="service-link">
              <div class="service-img-cont">
                <img loading="lazy" :src="getServiceImage(servicio.img)" :alt="servicio.name" class="service-img">
              </div>
              <h3>{{ servicio.name }}</h3>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div id="cifras">
      <div class="container">
        <div class="green-box text-center" data-aos="zoom-in">
          <h2 class="white pb-4">lo que hemos logrado en cifras</h2>
          <div class="row">
            <div class="col-lg-2 col-md-6 text-center pb-lg-0 pb-3" data-aos="fade-up" data-aos-delay="100">
              <p class="cifra light-green semibold">+45</p>
              <p class="p-16 semibold white">Años de experiencia</p>
            </div>
            <div class="col-lg-3 col-md-6 text-center pb-lg-0 pb-3" data-aos="fade-up" data-aos-delay="200">
              <p class="cifra light-green semibold">+120</p>
              <p class="p-16 semibold white">Contratos</p>
            </div>
            <div class="col-lg-3 col-md-6 text-center pb-lg-0 pb-3" data-aos="fade-up" data-aos-delay="300">
              <p class="cifra light-green semibold">+400</p>
              <p class="p-16 semibold white">Colaboradores</p>
            </div>
            <div class="col-lg-4 col-md-6 text-center pb-lg-0 pb-3" data-aos="fade-up" data-aos-delay="400">
              <p class="cifra light-green semibold">+1.500.000</p>
              <p class="p-14 semibold white">m² en limpieza integral solo en Santiago</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="proceso">
      <div class="container">
        <h2 data-aos="fade-up">CONTAMOS CON UN PROCESO DE SISTEMATIZACIÓN Y MEJORA CONTINUA</h2>
        <div class="row">
          <div class="col-lg-4" data-aos="fade-up" data-aos-delay="100">
            <div class="card-proceso">
              <img loading="lazy" src="@/assets/icons/process-icons/control_icon.svg" alt="icono planilla" class="process-icon">
              <p class="card-title pt-4">Control diario</p>
              <hr class="green-line">
              <p class="p-18 text-start">
                Contamos con supervisoras zonales que visitan a nuestros clientes regularmente para revisar materiales, su uso correcto, registro de asistencia, presentación personal, entre otros.
              </p>
            </div>
          </div>
          <div class="col-lg-4" data-aos="fade-up" data-aos-delay="200">
            <div class="card-proceso">
              <img loading="lazy" src="@/assets/icons/process-icons/calendar_icon.svg" alt="icono planilla" class="process-icon">
              <p class="card-title pt-4">Control mensual</p>
              <hr class="green-line">
              <p class="p-18 text-start">
                Realizamos un informe mensual, bimensual o trimestral, con una revisión detallada y profunda de las instalaciones, como baños, lavamanos, espejos, mobiliario y duchas.
              </p>
            </div>
          </div>
          <div class="col-lg-4" data-aos="fade-up" data-aos-delay="300">
            <div class="card-proceso">
              <img loading="lazy" src="@/assets/icons/process-icons/warning_icon.svg" alt="icono planilla" class="process-icon">
              <p class="card-title pt-4">Visita Prevencionista</p>
              <hr class="green-line">
              <p class="p-18 text-start">
                Según la necesidad del cliente, se llevan a cabo visitas para charlas de seguridad y verificar el cumplimiento de normas, como uso de zapatos de seguridad, rotulado, etc.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="frase">
      <img loading="lazy" src="@/assets/icons/forma_verde.svg" alt="forma verde" class="forma-izq">
      <img loading="lazy" src="@/assets/icons/forma_verde.svg" alt="forma verde" class="forma-der">
      <div class="container">
        <p class="white semibold" data-aos="fade-up">
          Conectamos nuestra trayectoria con tu visión, para crear espacios más seguros, productivos y personalizados.
        </p>
      </div>
    </div>
    <div id="equipo">
      <div class="container">
        <div class="row">
          <div class="col-lg-5 pe-lg-5 pb-lg-0 pb-4" data-aos="fade-right">
            <h2>Nuestro equipo</h2>
            <p class="p-16 pb-4">
              Contamos con un equipo de profesionales conocedores del mercado, que aseguran la calidad de nuestros servicios, teniendo como eje principal el control y supervisión en terreno de las diversas obras y capacitaciones constantes.
            </p>
            <ButtonComp 
              :btnColor="'btn-primary'" 
              :buttonText="'saber más'"
              :hashTag="'/somos'"
              :displayLink="true"
            />
          </div>
          <div class="col-lg-7 ps-lg-5" data-aos="fade-left">
            <CarouselTestimonios />
          </div>
        </div>
      </div>
    </div>
    <div id="clientes">
      <div class="container">
        <h2 data-aos="fade-up">Clientes destacados</h2>
        
        <!-- Carrusel para desktop -->
        <div class="d-none d-lg-block" data-aos="fade-up" data-aos-delay="100">
          <CarouselClientes />
        </div>
        
        <!-- Grid para mobile -->
        <div class="d-lg-none clients-grid" data-aos="fade-up" data-aos-delay="100">
          <div 
            v-for="(logo, index) in clientLogos" 
            :key="index"
            class="client-grid-item"
          >
            <img loading="lazy" 
              :src="getClientLogo(logo)" 
              :alt="`Logo ${logo.split('.')[0]}`"
              class="client-logo-grid"
            />
          </div>
        </div>
      </div>
    </div>
    <div id="contacto">
      <div class="container" data-aos="fade-up">
        <ContactBox />
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import ButtonComp from '../components/ButtonComp.vue'
import CarouselClientes from '../components/CarouselClientes.vue'
import CarouselTestimonios from '../components/CarouselTestimonios.vue'
import { mapState } from 'vuex'
import ContactBox from '@/components/ContactBox.vue'
export default {
  name: 'HomeView',
  components: {
    ButtonComp,
    CarouselClientes,
    CarouselTestimonios,
    ContactBox,
  },
  computed: {
    ...mapState(["services"]),
    servicios() {
      return this.services
    },
    clientLogos() {
      return this.$store.state.clientLogos
    }
  },
  methods: {
    getServiceImage(imageName) {

        return require(`@/assets/img/services-img/${imageName}`)
      
    },
    getClientLogo(logoName) {
      
        return require(`@/assets/logos/clients-logos/${logoName}`)
      
    }
  },
}
</script>
